exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2E6CQ{position:fixed;left:30px;bottom:30px}._1tAQI{width:300px;padding:10px;color:#fff;font-size:15px;background-color:rgba(0,0,0,.6)}@media (max-width:1780px){._2E6CQ{left:10px}}@media (max-width:1680px){._2E6CQ{display:none}}", ""]);

// exports
exports.locals = {
	"root": "_2E6CQ",
	"message": "_1tAQI"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/components/InfoMessages/InfoMessages.css
// module id = 2751
// module chunks = 32 36